import { render, staticRenderFns } from "./FormInfoPage.vue?vue&type=template&id=40240fc4&"
import script from "./FormInfoPage.vue?vue&type=script&lang=js&"
export * from "./FormInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40240fc4')) {
      api.createRecord('40240fc4', component.options)
    } else {
      api.reload('40240fc4', component.options)
    }
    module.hot.accept("./FormInfoPage.vue?vue&type=template&id=40240fc4&", function () {
      api.rerender('40240fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoPage/form/FormInfoPage.vue"
export default component.exports